import {
  Avatar,
  AvatarProps,
  Box,
  makeStyles,
  Theme,
  createStyles,
  Typography,
} from "@material-ui/core";
import { PropsWithChildren, ReactNode } from "react";

export type LabelWithAvatarProps = PropsWithChildren<{
  disableTypography?: boolean;
  src?: string | ReactNode;
  classes?: Partial<ReturnType<typeof useStyles>>;
}> &
  Pick<AvatarProps, "imgProps" | "sizes" | "alt" | "variant">;

export const LabelWithAvatar = (props: LabelWithAvatarProps) => {
  const {
    children,
    disableTypography = false,
    imgProps,
    src,
    sizes,
    alt,
    variant = "square",
  } = props;
  const classes = useStyles(props);

  return (
    <Box display="inline-flex" className={classes.root}>
      <Avatar
        imgProps={imgProps}
        src={typeof src === "string" ? src : undefined}
        sizes={sizes}
        alt={alt}
        variant={variant}
        className={classes.avatar}
        children={typeof src !== "string" && typeof src !== "undefined" ? src : undefined}
      />
      {disableTypography ? (
        children
      ) : (
        <Typography variant="body2" className={classes.typography}>
          {children}
        </Typography>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      fontSize: 14,
      verticalAlign: "middle",
    },
    avatar: {
      width: 16,
      height: 16,
      marginRight: 5,

      "& svg": {
        display: "block",
      },
    },
    typography: {
      fontWeight: "normal",
      fontSize: 14,
      lineHeight: 1.36,
    },
  }),
);
